module.exports = __webpack_public_path__ + "fonts/EuclidEnercity-BoldItalic-WebS.6a3c1cfa.woff2";